import * as actionTypes from './actionTypes';

export const fetchAllTags = () => ({
  type: actionTypes.FETCH_ALL,
});
export const fetchAllTagsSuccess = (ids) => ({
  type: actionTypes.FETCH_ALL_SUCCESS,
  ids,
});

export const createTag = (tag) => ({
  type: actionTypes.CREATE,
  tag,
});
export const createTagSuccess = (tag) => ({
  type: actionTypes.CREATE_SUCCESS,
  tag,
});

export const deleteTag = (tag) => ({
  type: actionTypes.DELETE,
  tag,
});
export const deleteTagSuccess = (id) => ({
  type: actionTypes.DELETE_SUCCESS,
  id,
});

export const updateTag = (tag) => ({
  type: actionTypes.UPDATE,
  tag,
});
export const updateTagSuccess = (id) => ({
  type: actionTypes.UPDATE_SUCCESS,
  id,
});

export const setActiveTagId = (id) => ({
  type: actionTypes.SET_ACTIVE_TAG_ID,
  id,
});
